import types from "./types";

const INITIAL_STATE = {
    isFetchedAllRoles: false,
    allRolesList: [],
    fetchingError: false,
    message: "",
};

const AvailableRolesReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
     case types.ALL_ROLES_GET_REQUEST:
      return Object.assign({}, state, {
        isFetchedAllRoles: false,
        fetchingError: false,
        message: false,
      });
    case types.ALL_ROLES_GET_RECEIVE:
      return Object.assign({}, state, {
        isFetchedAllRoles: true,
        allRolesList: action.response.roles,
        fetchingError: false,
        message: false,
      });
    case types.ALL_ROLES_GET_ERROR:
      return Object.assign({}, state, {
        isFetchedAllRoles: false,
        fetchingError: "An error occured while fetching all roles",
        message: false,
      });
      default:
        return state;
    }
};

export default AvailableRolesReducer;
